import { render, staticRenderFns } from "./SwitchUser.vue?vue&type=template&id=6afa8db2&"
import script from "./SwitchUser.vue?vue&type=script&lang=ts&"
export * from "./SwitchUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports